import { FulfillOrderAuthorization } from '../ts-client/authz';
import { FulfillOrderAuthorization as FulfillOrderAuthorizationProto } from '../proto/authz_pb';
import { toFixed } from '@cosmjs/math';

export const FULFILL_ORDER_AUTHORIZATION_TYPES = (authorizationValue: Uint8Array) => {
  const authorization = FulfillOrderAuthorization.decode(authorizationValue);
  return {
    TypeGrantAuthorizationValue: [
      { name: 'rollapps', type: 'TypeGrantAuthorizationValueRollapps[]' },
    ],
    TypeGrantAuthorizationValueRollapps: [
      { name: 'rollapp_id', type: 'string' },
      { name: 'denoms', type: 'string[]' },
      { name: 'max_price', type: 'TypeGrantAuthorizationValueRollappsMaxPrice[]' },
      { name: 'min_fee_percentage', type: 'TypeGrantAuthorizationValueRollappsMinFeePercentage' },
      { name: 'operator_fee_share', type: 'TypeGrantAuthorizationValueRollappsOperatorFeeShare' },
      ...(authorization.rollapps.some((rollapp) => rollapp.settlementValidated) ?
        [ { name: 'settlement_validated', type: 'bool' } ] :
        []),
      { name: 'spend_limit', type: 'TypeGrantAuthorizationValueRollappsSpendLimit[]' },
    ],
    TypeGrantAuthorizationValueRollappsMaxPrice: [
      { name: 'denom', type: 'string' },
      { name: 'amount', type: 'string' },
    ],
    TypeGrantAuthorizationValueRollappsMinFeePercentage: [
      { name: 'dec', type: 'string' },
    ],
    TypeGrantAuthorizationValueRollappsOperatorFeeShare: [
      { name: 'dec', type: 'string' },
    ],
    TypeGrantAuthorizationValueRollappsSpendLimit: [
      { name: 'denom', type: 'string' },
      { name: 'amount', type: 'string' },
    ],
  };
};

export function createFulfillOrderAuthorization(authorizationValue: Uint8Array) {
  const authorization = FulfillOrderAuthorization.decode(authorizationValue);
  return {
    type: 'eibc/FulfillOrderAuthorization',
    value: {
      rollapps: authorization.rollapps.map((rollapp) => ({
        rollapp_id: rollapp.rollappId,
        denoms: rollapp.denoms,
        max_price: rollapp.maxPrice,
        min_fee_percentage: { dec: toFixed(Number(rollapp.minFeePercentage?.dec || '0') / Math.pow(10, 18)) },
        operator_fee_share: { dec: toFixed(Number(rollapp.operatorFeeShare?.dec || '0') / Math.pow(10, 18)) },
        ...(rollapp.settlementValidated && { settlement_validated: rollapp.settlementValidated }),
        spend_limit: rollapp.spendLimit,
      })),
    },
  };
}

export const protoFulfillOrderAuthorization = (authorizationValue: Uint8Array) => {
  return {
    message: FulfillOrderAuthorizationProto.fromBinary(authorizationValue),
    path: FulfillOrderAuthorizationProto.typeName,
  };
};


